import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Cushion } from '@pitchero/react-ui';
import CricketBatIcon from '@pitchero/react-ui/dist/cjs/components/Icons/CricketBat';
import CricketBallIcon from '@pitchero/react-ui/dist/cjs/components/Icons/CricketBall';
import WicketsIcon from '@pitchero/react-ui/dist/cjs/components/Icons/Wickets';

import { isEmpty } from 'lodash';
import StatsCard from './stats-card';

const CricketStats = ({ stats }) => {
  if (isEmpty(stats)) {
    return null;
  }

  const { batting, bowling, fielding } = stats;

  return (
    <Cushion bottom="large">
      <Grid
        rowGap="medium"
        responsive={[
          {
            minWidth: 'lap',
            props: { columns: 'repeat(auto-fit, minmax(0px, 1fr))', columnGap: 'medium' },
          },
        ]}
      >
        {batting && (
          <StatsCard
            stats={batting.stats}
            titleI18nKey="teams:batting"
            IconComponent={CricketBatIcon}
            dismissals={batting.dismissals}
          />
        )}
        {bowling && (
          <StatsCard
            stats={bowling.stats}
            titleI18nKey="teams:bowling"
            IconComponent={CricketBallIcon}
            dismissals={bowling.dismissals}
          />
        )}
        {fielding && (
          <StatsCard
            IconComponent={WicketsIcon}
            stats={fielding.stats}
            titleI18nKey="teams:fielding"
            dismissals={fielding.dismissals}
          />
        )}
      </Grid>
    </Cushion>
  );
};

CricketStats.propTypes = {
  stats: PropTypes.shape({
    batting: PropTypes.shape(),
    bowling: PropTypes.shape(),
    fielding: PropTypes.shape(),
  }).isRequired,
};

export default CricketStats;
